"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Shops;
(function (Shops) {
    Shops["MARKET"] = "market";
    Shops["NONFOOD"] = "nonfood";
})(Shops || (Shops = {}));
exports.default = Shops;
